import { ColumnConfig } from "layout/TableConstructor/types";
import { PlatformVacancyListOrderFields } from "@generated/graphql";
import dayjs from "dayjs";
import { VacanciesFilter, VacancyItem } from "../types";

const columnConfig: ColumnConfig<VacancyItem, VacanciesFilter, PlatformVacancyListOrderFields, undefined>[] = [
  {
    name: "numericId",
    title: "ID вакансии",
    filterName: "numericId",
    sortField: PlatformVacancyListOrderFields.NumericId,
    render: (data) => data.numericId,
  },
  {
    name: "title",
    title: "Название",
    filterName: "title",
    sortField: PlatformVacancyListOrderFields.Title,
    render: (data) => data.title,
  },
  {
    name: "createdAt",
    title: "Дата создания",
    filterName: "createdAt",
    sortField: PlatformVacancyListOrderFields.CreatedAt,
    render: (data) => (data.createdAt ? dayjs(data.createdAt).format("DD.MM.YYYY") : "-"),
  },
  {
    name: "companyCandidatesCount",
    title: "Количество кандидатов",
    filterName: "companyCandidateCount",
    render: (data) => data.companyCandidatesCount || "-",
  },
];

export default columnConfig;
